/*eslint @typescript-eslint/no-explicit-any: 0*/
import Vue from 'vue';
import Vuex, { ActionTree, Module, StoreOptions } from 'vuex';
import { CommitOptions, DispatchOptions, GetterTree, MutationTree } from 'vuex';
import { IBUCPTState } from './contract';
import { TypedActions, TypedGetters, TypedMutations } from './CustomFundamentalStoreContracts';
import searchStore from './modules/search/searchStore';
import { rootOptions } from './root/rootStore';
import { IRootActions, IRootGetters, IRootMutations, IRootState } from './root/rootTypes';
import masterdataStore from './modules/masterdata/masterdataStore';
import displayStore from './modules/display/displayStore';

Vue.use(Vuex);

const modulesFactories = [displayStore, masterdataStore, searchStore];

const storeOptions: StoreOptions<IRootState> = {
  modules: modulesFactories.reduce((acc: { [key: string]: Module<any, any> }, curr) => {
    acc[curr.moduleName] = curr.getModule();
    return acc;
  }, {}),
  ...rootOptions,
};

class BUCPStore extends Vuex.Store<IRootState> {
  public state!: IBUCPTState;
  private actions: TypedActions<IRootActions>;
  private mutations: TypedMutations<IRootMutations>;
  private tGetters: TypedGetters<IRootGetters>;

  constructor(storeOps: StoreOptions<IRootState>) {
    super(storeOps);
    modulesFactories.forEach((factory) => factory.setRootStore(this));
    this.actions = this.extractActions(storeOps.actions);
    this.mutations = this.extractMutations(storeOps.mutations);
    this.tGetters = this.extractGetters(storeOps.getters);
  }

  // TODO: find cleaner way of making the dispatch function of the root Store typed

  public get _dispatch(): TypedActions<IRootActions> {
    return this.actions;
  }

  public get _commit(): TypedMutations<IRootMutations> {
    return this.mutations;
  }

  public get _getters(): TypedGetters<IRootGetters> {
    return this.tGetters;
  }

  // TODO: clean up code
  // * Try to find a way to type get rid of the unknown
  // * Try to write an extractor function which can be used in this code and in VuexModuleFactory
  // * Find a better way to expose typed getters (get rid of _commit, _getters, _dispatch)

  private extractMutations(mutations: MutationTree<IRootState> | undefined) {
    if (!mutations) {
      throw Error('Root store mutations not set correctly');
    }
    return Object.keys(mutations || {}).reduce((acc, curr) => {
      acc[curr] = (payload?: unknown, options?: CommitOptions) => this.commit(curr, payload, options);
      return acc;
    }, {} as any);
  }

  private extractGetters(getters: GetterTree<IRootState, IRootState> | undefined) {
    return Object.keys(getters || {}).reduce((acc, curr) => {
      acc[curr] = (param?: unknown) => {
        return param ? this.getters[curr](param) : this.getters[curr];
      };
      return acc;
    }, {} as any);
  }

  private extractActions(actions: ActionTree<IRootState, IRootState> | undefined) {
    if (!actions) {
      throw Error('Root store actions not set correctly');
    }
    return Object.keys(actions).reduce((acc, curr) => {
      acc[curr] = (payload?: unknown, options?: DispatchOptions) => this.dispatch(curr, payload, options);
      return acc;
    }, {} as any);
  }
}

export default new BUCPStore(storeOptions);
